export default {
      id: "flex-justifyContent-space-between-usage",
      viewBox: "0 0 40 40",
      url: "assets/" + "sprite.svg#flex-justifyContent-space-between-usage",
      toString: function () {
        return this.url;
      }
    }